module.exports = __webpack_public_path__ + "b9b4bd0aaf79983152bd98543c0d2e09.png";